import JOB_ROLE_TREE_OPTIONS from '@aibees/elephant/constants/job-role-tree-options.json';
import { humanReadableDepartment } from '@aibees/elephant/hooks/metrics/use-company-metrics';
import { CompanyDepartments } from '../../search-table-company/types';
import { SearchFilterTreeOptions } from '../types';

// for employee by department filter
export const departmentsOptions: SearchFilterTreeOptions[][] = [
  Object.keys(CompanyDepartments)
    .map((department, index) => {
      const label: string = humanReadableDepartment(
        department as CompanyDepartments
      );
      return {
        id: department,
        value: department,
        label,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label)),
];

// for headcount growth filter
export const departmentsOptionsForHeadcountGrowth: SearchFilterTreeOptions[][] =
  [
    [
      ...[
        {
          id: 'all',
          value: 'all',
          label: humanReadableDepartment('all' as CompanyDepartments),
        },
      ],
      ...Object.keys(CompanyDepartments)
        .map((department) => {
          const label: string = humanReadableDepartment(
            department as CompanyDepartments
          );
          return {
            id: department,
            value: department,
            label,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label)),
    ],
  ];

// for job role filter

export const jobRoleTreeOptions: SearchFilterTreeOptions[] =
  JOB_ROLE_TREE_OPTIONS;

export function getJobRoleTreeOptions() {
  const response = jobRoleTreeOptions.map((department) => ({
    ...department,
    children: department.children?.map((subDepartment) => ({
      ...subDepartment,
      value: `${department.value}::${subDepartment.value}`,
    })),
  }));
  return [response];
}

// here we get array of selected options values and return an array including those options plus all its children values
// the final array should be unique
export function mapJobRoleTreeOptionForBackend(selectedOptions: string[]) {
  const allValues = selectedOptions.flatMap((optionValue) => {
    const option = getJobRoleTreeOptions()
      .flat()
      .find((o) => o.value === optionValue);
    if (option) {
      const childrenValues =
        option.children?.map((subOption) => subOption.value) || [];
      return [option.value, ...childrenValues];
    }
    return [optionValue];
  });
  return Array.from(new Set(allValues));
}

/**
 * value -> display label for every department and job function in the tree.
 * Derived from job-role-tree-options.json so the taxonomy stays the single
 * source of truth; used by the applied-filter chip label formatter.
 */
export const JOB_FUNCTION_TRANSLATION: Record<string, string> =
  JOB_ROLE_TREE_OPTIONS.reduce<Record<string, string>>((acc, department) => {
    acc[department.value] = department.label;
    department.children?.forEach((subDepartment) => {
      acc[subDepartment.value] = subDepartment.label;
    });
    return acc;
  }, {});
